import React, { useState } from 'react';
import classnames from 'classnames';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import { Link } from 'react-router';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { isMobileFilter } from 'swag-client-common/utils/ui.utils';
import placeholder from 'assets/img/image-placeholder.png';
import classes from './promoted-products-block.scss';
export const PromotedProductsBlock = ({
  headingText,
  products
}) => {
  const storeSettings = window.swag.storeSettings;
  const isInIFrame = window.self !== window.top;
  const shouldShowImagePlaceholder = (!products || !products.length) && isInIFrame;
  const defaultHeadingText = `Top Picks${storeSettings !== null && storeSettings !== void 0 && storeSettings.companyName ? ` by ${storeSettings.companyName}` : ''}`;
  if ((!products || !products.length) && !isInIFrame) {
    return null;
  }
  if (shouldShowImagePlaceholder) {
    products = new Array(3).fill(0).map((_, i) => ({
      productName: `Product ${i + 1}`,
      imgUrl: placeholder,
      seoSlug: '/'
    }));
  }
  const pageSize = isMobileFilter() ? 1 : 3;
  const [currentPage, setPage] = useState(0);
  const firstPage = currentPage === 0;
  const lastPage = currentPage + pageSize === products.length;
  const handleLeftClick = () => {
    if (!firstPage) {
      setPage(currentPage - 1);
    }
  };
  const handleRightClick = () => {
    if (!lastPage) {
      setPage(currentPage + 1);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.root
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.content
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.title
  }, headingText || defaultHeadingText), /*#__PURE__*/React.createElement("div", {
    className: classes.productsWrapper
  }, products.slice(currentPage, currentPage + pageSize).map(({
    productName,
    imgUrl,
    seoSlug
  }) => /*#__PURE__*/React.createElement("div", {
    className: classes.product
  }, /*#__PURE__*/React.createElement(Link, {
    to: `${APP_ROUTES.PRODUCT}/${seoSlug}`
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.imageWrapper
  }, /*#__PURE__*/React.createElement("img", {
    src: imgUrl,
    className: classnames(classes.image, {
      [classes.placeholder]: shouldShowImagePlaceholder
    })
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.text
  }, productName))))), products.length > pageSize && /*#__PURE__*/React.createElement("div", {
    className: classes.controls
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.arrow, classes.left, {
      [classes.disabled]: firstPage
    }),
    onClick: handleLeftClick
  }, /*#__PURE__*/React.createElement(ChevronRightIcon, null)), /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.arrow, {
      [classes.disabled]: lastPage
    }),
    onClick: handleRightClick
  }, /*#__PURE__*/React.createElement(ChevronRightIcon, null)))));
};